import { useEnv } from 'apprise-frontend-core/env'
import { createProvider, createReadonlyProvider } from 'apprise-frontend-core/state/factory'


// gloabal toggle policy: consulted to know if a tag is active.
// ------------------------------------------------------------------------------------------------------------------------------

type PolicyState = {

    given: (_: string[]) => { isFeatureEnabled: (_: string) => boolean }
}


export const useOptOutPolicy = (toggles: string[]) => {

    const env = useEnv()

    return { isFeatureEnabled: (toggle: string) => env.name !== 'production' && !toggles.includes(toggle) } 

}

export const [TogglePolicy, useTogglePolicy] = createProvider<PolicyState>({

    given: useOptOutPolicy

})


// local toggle config: holds active toggles.
// ------------------------------------------------------------------------------------------------------------------------------


export type ToggleConfig<T extends string = string> = {

    toggles: T[] | readonly T[]
}

export const createToggleProvider = <T extends string = string>() => {


    const [ToggleProvider, useToggles] = createReadonlyProvider<ToggleConfig<T>>({
        toggles: []
    })

    // wraps hook to local toggles to enforce global policy.
    
    const useToggleWithPolicy = () => {

        const { toggles } = useToggles()
        const policy = useTogglePolicy().get()
        const policyImpl = policy.given([...toggles])

        return {

            isFeatureEnabled: (toggle: T) => policyImpl.isFeatureEnabled(toggle)

        }
    }

    return [ToggleProvider, useToggleWithPolicy] as [typeof ToggleProvider, typeof useToggleWithPolicy]
}
